import React, { useRef } from "react";
import { Input } from "antd";

const OTPInput = ({ length = 6, value = "", onChange, autoFocus = true }) => {
  const inputsRef = useRef([]);

  const values = value
    .split("")
    .concat(Array(length).fill(""))
    .slice(0, length);

  const focusInput = (index) => {
    if (inputsRef.current[index]) {
      inputsRef.current[index].focus();
    }
  };

  const handleChange = (val, index) => {
    if (!/^\d?$/.test(val)) return;

    const newValues = [...values];
    newValues[index] = val;
    const newValue = newValues.join("");

    if (onChange) onChange(newValue);

    if (val && index < length - 1) {
      focusInput(index + 1);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!values[index] && index > 0) {
        focusInput(index - 1);
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      focusInput(index - 1);
    }

    if (e.key === "ArrowRight" && index < length - 1) {
      focusInput(index + 1);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text").replace(/\D/g, "");
    const sliced = pastedData.slice(0, length);

    const padded = sliced
      .split("")
      .concat(Array(length).fill(""))
      .slice(0, length);

    if (onChange) onChange(padded.join(""));

    const nextIndex = Math.min(sliced.length, length - 1);
    focusInput(nextIndex);
  };

  return (
    <div style={{ display: "flex", gap: 8 }}>
      {Array.from({ length }).map((_, index) => (
        <Input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          value={values[index]}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          maxLength={1}
          autoFocus={autoFocus && index === 0}
          style={{
            width: 48,
            height: 48,
            textAlign: "center",
            fontSize: 20,
            fontWeight: 600,
            borderRadius: 8,
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;
